var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){return _vm.onClick()}}},[(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label))]):_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }